export class Constants {
  static readonly ENCODING = 'UTF-8';
  static readonly CONTENT_TYPE = 'application/json';
  static readonly HTTP_REQUEST_DURATION = 60000;
  static readonly TIMEOUT_ERROR_NOT_NETWORK = 4000;
  static readonly SPINNER_DURAION = 180000;
  static readonly TOASTR_DURATION = 5000;
  static readonly TOKEN = 'agendmedical.token';

  static readonly API_URL_CREATESURVEY = 'CreateSurvey';
  static readonly API_URL_GET_LOV = 'GetLOV';
  static readonly API_URL_GET_TEMPTOKEN = 'GetTempToken';
  static readonly API_URL_GETTOKEN = 'GetToken';
  static readonly API_URL_PARAMETERS = 'GetParams';
  static readonly API_URL_QUERY = 'Query';
  static readonly API_METHOD_CREATESURVEY = 'createSurvey';
  static readonly API_METHOD_GET_ACCOUNT = 'getContact';
  static readonly API_METHOD_GET_BRAND = 'getBrand';
  static readonly API_METHOD_GET_LOV = 'getLOV';
  static readonly API_METHOD_GET_PARTNER = 'getPartner';
  static readonly API_METHOD_GET_TEMPTOKEN = 'getTempToken';
  static readonly API_METHOD_LOGIN = 'authorization';
  static readonly API_METHOD_PARAMETERS = 'getParams';
  static readonly API_METHOD_SET_ACCOUNT = 'setContact';

  static readonly PHONE_PREFIX = '+38';
  static readonly PHONE_PREFIX_L = '+380';
  static readonly PHONE_MASK = '999 999 9999';
  static readonly PHONE_MASK_L = '99 999 9999';
  static readonly PHONE_MASK_FULL = '~99 999 999 9999';

  static readonly PATTERN_FULL_DATE_EN = 'MM.dd.yyyy';
  static readonly PATTERN_FULL_DATE_UA = 'dd.MM.yyyy';

  static readonly STORAGE_PREFIX = 'AGEnd.';

  static readonly FAKE_DATA_ON = false;
}
